<template>
  <footer class="appsumo-footer">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4 col-lg-3">
          <img
            class="sumo-footer-logo mb-3"
            width="130"
            height="20"
            alt="footer logo"
            src="@legacy/static/images/home/as-appsumo-logo-footer.svg"
          >
          <p class="sumo-footer-text">
            Part of the
            <a
              href="https://sumo.com/"
              target="_blank"
              rel="noopener"
              class="sumo-link"
            >Sumo</a>
            family with
            <a
              href="https://sendfox.com/"
              target="_blank"
              rel="noopener"
              class="sumo-link"
            >SendFox</a>
            and
            <a
              href="https://tidycal.com/"
              target="_blank"
              rel="noopener"
              class="sumo-link"
            >TidyCal</a>
          </p>

          <FooterSocialLinks class="d-none d-md-flex" />
        </div>

        <div class="col-6 col-md-2">
          <h4>
            Account
          </h4>
          <ul class="list-unstyled">
            <li class="mb-2">
              <!-- Nuxt redirects to login as internal page,
                we use Nuxtlink only for logged in users  -->
              <NuxtLink
                v-if="user"
                class="sumo-link"
                to="/account/"
              >
                Account overview
              </NuxtLink>
              <a
                v-else
                class="sumo-link"
                href="/account/"
              >
                Account overview
              </a>
            </li>
            <li class="mb-2">
              <NuxtLink
                v-if="user && user.has_plus"
                class="sumo-link"
                to="/account/plus/"
              >
                Plus
              </NuxtLink>
              <a
                v-else
                class="sumo-link"
                href="/plus/"
              >
                Join Plus
              </a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="https://help.appsumo.com/"
                target="_blank"
                rel="noopener"
              >
                Help center
              </a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="/terms-of-use/"
                target="_blank"
                rel="noopener"
              >Terms</a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="/privacy/"
              >Privacy</a>
            </li>
          </ul>
        </div>

        <div class="col-6 col-md-2">
          <h4>
            AppSumo
          </h4>

          <ul class="list-unstyled">
            <li class="mb-2">
              <a
                class="sumo-link"
                href="/about/"
              >
                About
              </a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="https://blog.appsumo.com/"
                target="_blank"
                rel="noopener"
              >Blog</a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="/careers/"
              >Careers</a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="https://go.appsumo.com/become-appsumo-affiliate/"
              >Affiliates</a>
            </li>
          </ul>
        </div>

        <div class="col-6 col-md-2">
          <h4>
            Sell
          </h4>
          <ul class="list-unstyled">
            <li class="mb-2">
              <a
                class="sumo-link"
                href="https://appsumo.com/select/"
                target="_blank"
                rel="noopener"
              >AppSumo Select</a>
            </li>
            <li class="mb-2">
              <a
                href="https://sell.appsumo.com/"
                class="sumo-link"
                target="_blank"
                rel="noopener"
              >List your own product</a>
            </li>
            <li class="mb-2">
              <a
                href="/case-studies/"
                class="sumo-link"
              >Case studies</a>
            </li>
          </ul>
        </div>

        <div class="col-6 col-md-2">
          <h4>
            Learn
          </h4>

          <ul class="list-unstyled">
            <li class="mb-2">
              <a
                class="sumo-link"
                href="https://appsumo.com/content/how-to-start-an-online-business/"
                target="_blank"
                rel="noopener"
              >How to start an online business</a>
            </li>
            <li class="mb-2">
              <a
                class="sumo-link"
                href="https://appsumo.com/content/what-is-the-creator-economy/"
                target="_blank"
                rel="noopener"
              >What is the creator economy?</a>
            </li>
          </ul>
        </div>
      </div>

      <FooterSocialLinks class="d-md-none" />
    </div>
  </footer>
</template>

<script>
import FooterSocialLinks from './FooterSocialLinks';

export default {
  components: {
    FooterSocialLinks,
  },
  head() {
    const organization = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'AppSumo',
      url: 'https://appsumo.com',
      logo: 'https://appsumo2nuxt-cdn.appsumo.com/as-appsumo-logo-dark.svg',
      sameAs: [
        'https://twitter.com/AppSumo',
        'https://www.instagram.com/appsumo/',
        'https://www.facebook.com/appsumo/',
        'https://www.youtube.com/channel/UCRrAZbOmqB3pX7dWHC_-wEQ',
        'https://www.tiktok.com/@appsumo',
      ],
    };

    return {
      script: [{
        hid: 'organization-schema',
        type: 'application/ld+json',
        innerHTML: JSON.stringify(organization, null, '\t'),
      }],
      // avoid encoding (&quot; instead ")
      __dangerouslyDisableSanitizersByTagID: {
        'organization-schema': ['innerHTML'],
      },
    };
  },
  computed: {
    user() {
      return this.$store.getters.userSession;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~/styles/dorado/themes/dorado';
@import '~/styles/utils/breakpoints';

.appsumo-footer {
  background-color: $forest;
  color: $white;
  min-height: initial;
  padding: 3rem 0;

  // same as .sumo-browse-main
  .container {
    max-width: 2000px;
    padding: 0 30px;
  }

  .row {
    gap: 2rem 0;
  }

  ::v-deep .sumo-link {
    color: inherit;
    display: inline-block;
    font-size: 0.875rem;
    max-width: 150px;
  }

  .sumo-footer-text {
    font-size: 0.75rem;

    .sumo-link {
      font-size: inherit;
    }
  }

  ::v-deep .sumo-link:hover,
  ::v-deep .sumo-link:focus {
    color: rgba($white, 0.68);
    text-decoration: none;
  }

  ::v-deep .sumo-social-links {
    margin-top: 2rem;
  }
}

@include media-breakpoint-up(md) {
  .appsumo-footer {
    .sumo-footer-text {
      margin: 0;
      max-width: 190px;
    }

    ::v-deep .sumo-social-links {
      margin-top: 1rem;
    }
  }
}
</style>
